import type {
  IResponseApi
} from '@/modules/Core/interfaces/api/IApis'
import { BaseService } from '@/modules/Core/services/BaseService'
import { AxiosError, type AxiosResponse } from 'axios'
import type { IMenuAuth } from '@/modules/Autenticacion/interfaces'
import type { IConfEntidades } from '@/modules/Configuracion/interfaces'
import type { ILicencia } from '@/modules/Autenticacion/interfaces/IFathersAuthItem'
import type { IConfLicencia, ICertificadoLicencia, TipoCertificadoLicencia } from '@/modules/Configuracion/interfaces'
export class AuthService extends BaseService<unknown> {
  constructor () {
    super({
      baseUrl: 'auth/'
    })
  }
  async usermenu (): Promise<AxiosResponse<IResponseApi<IMenuAuth[]>>> {
    return this.http.get<IResponseApi<IMenuAuth[]>>(`/usermenu`).catch(this.errorHandle)
  }
  async healcheck (): Promise<AxiosResponse<IResponseApi<Record<string,unknown>>>> {
    return this.http.get<IResponseApi<Record<string,unknown>>>(`/healcheck`).catch(this.errorHandle)
  }
  async licencia (): Promise<AxiosResponse<IResponseApi<ILicencia|string>>> {
    return this.http.get<IResponseApi<ILicencia|string>>(`/licencia`).catch(this.errorHandle)
  }
  async cambiarEntidad (
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http.post<IResponseApi<string>>(`/change-entity`, params).catch(this.errorHandle)
  }
  async login (
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<unknown>>> {
    try {
      const respuesta = await this.http.post<IResponseApi<unknown>>('/login', params)
      return respuesta
    } catch (error) {
      if (error instanceof AxiosError && error.response?.status === 403) throw error
      this.errorHandle(error as AxiosError)
      throw error
    }
  }
  async validarUser (
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<IConfEntidades[]>>> {
    return this.http.post<IResponseApi<IConfEntidades[]>>(
      `/validate-user`,
      params
    ).catch(this.errorHandle)
  }
  async validarToken (
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<string>>> {
    try {
      const respuesta = await this.http.post<IResponseApi<string>>('/validate-two-facto', params)
      return respuesta
    } catch (error) {
      if (error instanceof AxiosError && error.response?.status === 403) throw error
      this.errorHandle(error as AxiosError)
      throw error
    }
  }
  async activarTwoFactor (
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<object|string>>> {
    return this.http.post<IResponseApi<object|string>>(`/active-two-factor`, params).catch(this.errorHandle)
  }
  async requestReset (
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<unknown>>> {
    return this.http.post<IResponseApi<unknown>>(`/request-reset`, params).catch(this.errorHandle)
  }
  async verifyReset (
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<unknown>>> {
    return this.http.post<IResponseApi<unknown>>(`/verify-reset`, params).catch(this.errorHandle)
  }
  async resetPassword (
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<unknown>>> {
    return this.http.post<IResponseApi<unknown>>(`/reset-password`, params).catch(this.errorHandle)
  }
  async misLicencias(): Promise<AxiosResponse<IResponseApi<IConfLicencia[]>>> {
    return this.http
      .get<IResponseApi<IConfLicencia[]>>('/licencias')
      .catch(this.errorHandle)
  }
  async certificadoSoftware(id: number, tipo: TipoCertificadoLicencia): Promise<AxiosResponse<IResponseApi<ICertificadoLicencia>>> {
    return this.http
      .get<IResponseApi<ICertificadoLicencia>>(`/licencias/${id}/certificados/${tipo}`)
      .catch(this.errorHandle)
  }
  // Buscar elementos con parámetros
}
